import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const DownloadIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        d="m12 15.45-3.1-3.1.5-.5 2.25 2.25V5.3h.7v8.8l2.25-2.25.5.5-3.1 3.1ZM5.3 18.7v-3.75H6V18h12v-3.05h.7v3.75H5.3Z"
      />
    </svg>
  </IconWrapper>
));
